/* Brents quick-add drawer — phones only.
   Reference for the UX (not the look): the SKIMS mobile grid, where the "+" on a product
   photo opens a bottom sheet and the whole buy decision — colour, size, add — happens
   without leaving the collection. Everything visual here is Brents: FT Milky, #000 ink,
   #943130 for the live button, #d9d9d9 borders, 0.4rem radii.

   The drawer is built once and appended to <body>, then populated from the JSON payload
   each card carries in [data-card-quick-data] (written by snippets/brents-product-card.liquid).
   One sheet serves every card on the page, so a 9-card grid costs one dialog, not nine.

   The add goes straight to /cart/add.js rather than through Dawn's <product-form>, because
   the card's form is fixed to one variant and the drawer's whole job is changing it. The
   cart drawer is re-rendered the same way product-form does it, so the bag behaves as usual.

   Loaded by sections/brents-collection-grid.liquid and sections/brents-product-carousel.liquid.
   Guarded so a second copy on the same page is a no-op. */
(function () {
  if (window.BrentsQuickAdd) return;

  var sheet = null;
  var el = {};
  var state = { data: null, card: null, color: null, size: null, variant: null, opener: null };

  /* ---------- helpers over the payload ---------- */

  function hits(color, size) {
    var d = state.data;
    if (!d) return [];
    return d.variants.filter(function (v) {
      if (d.colorIndex >= 0 && color != null && v.o[d.colorIndex] !== color) return false;
      if (d.sizeIndex >= 0 && size != null && v.o[d.sizeIndex] !== size) return false;
      return true;
    });
  }

  function pick(color, size) {
    var list = hits(color, size);
    for (var i = 0; i < list.length; i++) {
      if (list[i].available) return list[i];
    }
    return list[0] || null;
  }

  function cheapest(list) {
    var best = null;
    list.forEach(function (v) {
      if (!best || v.price < best.price) best = v;
    });
    return best;
  }

  function anyAvailable(color) {
    return hits(color, null).some(function (v) {
      return v.available;
    });
  }

  function str(key, fallback) {
    var s = state.data && state.data.strings;
    return (s && s[key]) || fallback;
  }

  /* ---------- build once ---------- */

  function build() {
    if (sheet) return;

    sheet = document.createElement('div');
    sheet.className = 'bqa';
    sheet.hidden = true;
    sheet.innerHTML = [
      '<div class="bqa__scrim" data-bqa-close></div>',
      '<div class="bqa__sheet" role="dialog" aria-modal="true" aria-labelledby="bqa-title" tabindex="-1">',
      '<div class="bqa__grip" aria-hidden="true"></div>',
      '<div class="bqa__head">',
      '<div class="bqa__headings">',
      '<h2 class="bqa__title" id="bqa-title"></h2>',
      '<p class="bqa__price"></p>',
      '</div>',
      '<button type="button" class="bqa__close" data-bqa-close>',
      '<svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true" focusable="false">',
      '<path d="M4.5 4.5l11 11M15.5 4.5l-11 11" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>',
      '</svg>',
      '</button>',
      '</div>',
      '<p class="bqa__colour"></p>',
      '<div class="bqa__thumbs"></div>',
      '<p class="bqa__label"></p>',
      '<div class="bqa__sizes"></div>',
      '<p class="bqa__error" hidden></p>',
      '<button type="button" class="bqa__cta"></button>',
      '</div>'
    ].join('');

    document.body.appendChild(sheet);

    el.dialog = sheet.querySelector('.bqa__sheet');
    el.title = sheet.querySelector('.bqa__title');
    el.price = sheet.querySelector('.bqa__price');
    el.colour = sheet.querySelector('.bqa__colour');
    el.thumbs = sheet.querySelector('.bqa__thumbs');
    el.label = sheet.querySelector('.bqa__label');
    el.sizes = sheet.querySelector('.bqa__sizes');
    el.error = sheet.querySelector('.bqa__error');
    el.cta = sheet.querySelector('.bqa__cta');
    el.close = sheet.querySelector('.bqa__close');

    sheet.querySelectorAll('[data-bqa-close]').forEach(function (node) {
      node.addEventListener('click', close);
    });
    el.cta.addEventListener('click', addToCart);
  }

  /* ---------- render ---------- */

  function render() {
    var d = state.data;

    el.title.textContent = d.title;
    el.close.setAttribute('aria-label', str('close', 'Close'));

    /* colour line + thumbnails */
    var multi = d.colorIndex >= 0 && d.colors && d.colors.length > 1;
    if (d.colorIndex >= 0 && state.color) {
      el.colour.innerHTML = '';
      var lab = document.createElement('span');
      lab.className = 'bqa__colour-label';
      lab.textContent = (d.colorName || 'Color') + ':';
      var val = document.createElement('span');
      val.className = 'bqa__colour-name';
      val.textContent = state.color;
      el.colour.appendChild(lab);
      el.colour.appendChild(val);
      el.colour.hidden = false;
    } else {
      el.colour.hidden = true;
    }

    el.thumbs.innerHTML = '';
    if (multi) {
      d.colors.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bqa__thumb';
        b.setAttribute('aria-label', c.name);
        b.setAttribute('aria-pressed', c.name === state.color ? 'true' : 'false');
        if (c.name === state.color) b.classList.add('is-current');
        if (!anyAvailable(c.name)) b.classList.add('is-soldout');
        if (c.image) {
          var img = document.createElement('img');
          img.src = c.image;
          img.alt = '';
          img.loading = 'lazy';
          b.appendChild(img);
        } else {
          var txt = document.createElement('span');
          txt.className = 'bqa__thumb-text';
          txt.textContent = c.name;
          b.appendChild(txt);
        }
        b.addEventListener('click', function () {
          if (state.color === c.name) return;
          state.color = c.name;
          state.size = null;
          el.error.hidden = true;
          render();
        });
        el.thumbs.appendChild(b);
      });
      el.thumbs.hidden = false;
    } else {
      el.thumbs.hidden = true;
    }

    /* sizes */
    var needSize = d.sizeIndex >= 0 && d.sizes && d.sizes.length > 0;
    el.sizes.innerHTML = '';
    if (needSize) {
      el.label.textContent = d.sizeName || 'Size';
      d.sizes.forEach(function (s) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bqa__size';
        b.textContent = s;
        var ok = hits(state.color, s).some(function (v) {
          return v.available;
        });
        if (!ok) {
          b.classList.add('is-unavailable');
          b.disabled = true;
        }
        if (s === state.size) b.classList.add('is-current');
        b.setAttribute('aria-pressed', s === state.size ? 'true' : 'false');
        b.addEventListener('click', function () {
          state.size = s;
          el.error.hidden = true;
          render();
        });
        el.sizes.appendChild(b);
      });
      el.sizes.hidden = false;
      el.label.hidden = false;
    } else {
      el.sizes.hidden = true;
      el.label.hidden = true;
    }

    /* price: the chosen variant once a size is picked, otherwise this colour's lowest */
    var shown = state.size ? pick(state.color, state.size) : cheapest(hits(state.color, null));
    el.price.textContent = shown ? shown.priceText : '';

    /* call to action */
    var chosen = needSize ? (state.size ? pick(state.color, state.size) : null) : pick(state.color, null);
    state.variant = chosen;

    if (needSize && !state.size) {
      el.cta.textContent = str('selectSize', 'Select a Size');
      el.cta.disabled = true;
      el.cta.classList.add('is-idle');
    } else if (!chosen || !chosen.available) {
      el.cta.textContent = str('soldOut', 'Sold Out');
      el.cta.disabled = true;
      el.cta.classList.add('is-idle');
    } else {
      el.cta.textContent = str('add', 'Add to Cart');
      el.cta.disabled = false;
      el.cta.classList.remove('is-idle');
    }
  }

  /* ---------- add ---------- */

  function addToCart() {
    var v = state.variant;
    if (!v || !v.available) return;

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = new FormData();
    body.append('id', v.id);
    body.append('quantity', 1);
    if (cart && cart.getSectionsToRender) {
      body.append(
        'sections',
        cart
          .getSectionsToRender()
          .map(function (s) {
            return s.id;
          })
          .join(',')
      );
      body.append('sections_url', window.location.pathname);
    }

    el.cta.classList.add('is-loading');
    el.cta.disabled = true;
    el.error.hidden = true;

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        el.cta.classList.remove('is-loading');
        el.cta.disabled = false;
        if (res.status) {
          el.error.textContent = res.description || res.message || str('error', 'Could not add to cart.');
          el.error.hidden = false;
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'brents-quick-add',
            productVariantId: v.id,
            cartData: res
          });
        }
        close();
        if (cart && cart.renderContents) {
          cart.renderContents(res);
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
      })
      .catch(function () {
        el.cta.classList.remove('is-loading');
        el.cta.disabled = false;
        el.error.textContent = str('error', 'Could not add to cart.');
        el.error.hidden = false;
      });
  }

  /* ---------- open / close ---------- */

  function onKey(e) {
    if (e.key === 'Escape') close();
  }

  function open(card) {
    var node = card.querySelector('[data-card-quick-data]');
    if (!node) return;
    var data;
    try {
      data = JSON.parse(node.textContent);
    } catch (e) {
      return;
    }

    build();

    state.data = data;
    state.card = card;
    state.opener = card.querySelector('[data-card-quick]');
    state.size = null;
    state.color = null;

    if (data.colorIndex >= 0 && data.colors && data.colors.length) {
      var names = data.colors.map(function (c) {
        return c.name;
      });
      /* a colour card opens on its own colourway; otherwise the first one still in stock */
      var want = card.getAttribute('data-card-color') || data.current;
      if (want && names.indexOf(want) >= 0) {
        state.color = want;
      } else {
        state.color =
          names.filter(function (n) {
            return anyAvailable(n);
          })[0] || names[0];
      }
    }

    el.error.hidden = true;
    render();

    sheet.hidden = false;
    document.body.classList.add('overflow-hidden');
    window.requestAnimationFrame(function () {
      sheet.classList.add('is-in');
    });
    document.addEventListener('keydown', onKey);
    window.setTimeout(function () {
      el.dialog.focus();
    }, 60);
  }

  function close() {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-in');
    document.removeEventListener('keydown', onKey);
    document.body.classList.remove('overflow-hidden');
    var opener = state.opener;
    window.setTimeout(function () {
      sheet.hidden = true;
    }, 300);
    if (opener && typeof opener.focus === 'function') opener.focus();
  }

  /* ---------- wiring ---------- */

  function bind(root) {
    (root || document).querySelectorAll('[data-card-quick]').forEach(function (btn) {
      if (btn.dataset.bqaReady) return;
      btn.dataset.bqaReady = '1';
      /* the well runs a press-and-hold gesture; keep this tap out of it */
      btn.addEventListener('pointerdown', function (e) {
        e.stopPropagation();
      });
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var card = btn.closest('[data-bcard]');
        if (card) open(card);
      });
    });
  }

  window.BrentsQuickAdd = { bind: bind, open: open, close: close };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bind();
    });
  } else {
    bind();
  }
  document.addEventListener('shopify:section:load', function (e) {
    bind(e.target);
  });
})();